import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';

import { SectionContentLinkListIdTwo } from 'components/section-content-link-list';
import { TitleAnchor } from 'components/title-anchor';
import { FormattedText, P1 } from 'components/typography';

const setTitleElement = (id: SectionContentLinkListIdTwo) => {
  const mapTitleAnchorToSectionId: {
    [key in SectionContentLinkListIdTwo]: {
      id: SectionContentLinkListIdTwo;
      title: string;
    };
  } = {
    [SectionContentLinkListIdTwo.UsingYourInformation]: {
      id: SectionContentLinkListIdTwo.UsingYourInformation,
      title: sections.tabTwoSection.section1.title(),
    },

    [SectionContentLinkListIdTwo.OurMatchingAlgorithms]: {
      id: SectionContentLinkListIdTwo.OurMatchingAlgorithms,
      title: sections.tabTwoSection.section2.title(),
    },

    [SectionContentLinkListIdTwo.ModerationPractices]: {
      id: SectionContentLinkListIdTwo.ModerationPractices,
      title: sections.tabTwoSection.section3.title(),
    },
    [SectionContentLinkListIdTwo.LawfulBasis]: {
      id: SectionContentLinkListIdTwo.LawfulBasis,
      title: sections.tabTwoSection.section4.title(),
    },
    [SectionContentLinkListIdTwo.BeePitched]: {
      id: SectionContentLinkListIdTwo.BeePitched,
      title: sections.tabTwoSection.section5.title(),
    },
    [SectionContentLinkListIdTwo.ConnectionQuizzes]: {
      id: SectionContentLinkListIdTwo.ConnectionQuizzes,
      title: sections.tabTwoSection.section6.title(),
    },
  };

  return <TitleAnchor {...mapTitleAnchorToSectionId[id]} />;
};

export const getPropsSectionTwoContainer = ({ lang }: { lang: SupportedLanguage }) => {
  return {
    sections: {
      one: {
        titleElement: setTitleElement(SectionContentLinkListIdTwo.UsingYourInformation),
        text: (
          <FormattedText>
            <P1
              as="div"
              html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionOneColumnLeftText()}
            />
            <P1
              as="div"
              html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionOneColumnLeftText2()}
            />
            <ul className="ul-list">
              <li>
                <P1
                  as="p"
                  html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionOneColumnLeftText3()}
                />
              </li>
            </ul>
            <P1
              as="p"
              html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionOneColumnLeftText4()}
            />
            <P1
              as="p"
              html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionOneColumnLeftText5()}
            />
          </FormattedText>
        ),
        goodToKnow: {
          title: sections.tabTwoSection.goodToKnow(),
          content: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSection1GoodToKnowContent(),
        },
        // @TODO: To remove, once it is replaced in consumers
        imageSrc: `${CdnImagePath}/landing/assets/photos/landing-section-1-Good-to-know.png`,
        imageAlt: '',
        imageObjectPosition: 'top center',
      },
      two: {
        imageSrc: `${CdnImagePath}/assets/tab-02/tab-02-02.jpg`,
        imageAlt: '',
        imageObjectPosition: 'top center',
        titleElement: setTitleElement(SectionContentLinkListIdTwo.OurMatchingAlgorithms),
        text: (
          <FormattedText>
            <P1 as="p">{sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionTwoText1()}</P1>
            <P1 as="p">{sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionTwoText2()}</P1>
            <P1 html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionTwoText3()} as="div" />
            <P1 html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionTwoText4()} as="p" />
            <P1 html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionTwoText5()} as="div" />
            <P1 html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionTwoText6()} as="div" />
          </FormattedText>
        ),
        tip: <P1 as="p">{sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSection2Tip()}</P1>,
      },
      three: {
        titleElement: setTitleElement(SectionContentLinkListIdTwo.ModerationPractices),
        text: (
          <FormattedText>
            <P1 html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionThreeText()} as="p" />
            <P1 as="p">{sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionThreeText2()}</P1>
          </FormattedText>
        ),
        //sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionThreeText(),
        imageSrc: `${CdnImagePath}/assets/tab-02/tab-02-03.jpg`,
        imageTipTitle: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionThreeImageTipTitle(),
        imageTipContent:
          sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionThreeImageTipContent(),
      },
      four: {
        imageSrc: `${CdnImagePath}/landing/assets/photos/landing-section-1-Good-to-know.png`,
        imageAlt: '',
        imageObjectPosition: 'top center',
        titleElement: setTitleElement(SectionContentLinkListIdTwo.LawfulBasis),
        text: (
          <FormattedText>
            <P1
              html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionFourTextOne()}
              as="p"
            />
            <P1
              html={sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionFourTextTwo()}
              as="p"
            />
          </FormattedText>
        ),
        goodToKnow: {
          title: sections.tabTwoSection.goodToKnow(),
          content: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSection4GoodToKnowContent(),
        },
        ccpa: {
          title: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSection4CCPATitle(),
          content: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSection4CCPAContent({ lang }),
        },
      },
      five: {
        table: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionFiveTable(),
        titleElement: setTitleElement(SectionContentLinkListIdTwo.BeePitched),
        text1: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionFiveTextOne(),
        text2: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionFiveTextTwo(),
        text3: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionFiveTextThree(),
        text4: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionFiveTextFour(),
        text5: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionFiveTextFive(),
      },
      six: {
        titleElement: setTitleElement(SectionContentLinkListIdTwo.ConnectionQuizzes),
        text1: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionSixTextOne(),
        text2: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionSixTextTwo(),
        text3: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionSixTextThree(),
        text4: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionSixTextFour(),
        text5: sections.tabTwoSection.lxPagePrivacyPolicyTabTwoSectionSixTextFive(),
      },
    },
  };
};
